import { render } from "./SocialDiscord.vue?vue&type=template&id=07eed836"
import script from "./SocialDiscord.vue?vue&type=script&lang=js"
export * from "./SocialDiscord.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__